const baseUri = 'orders';

export default {

  index(query, limit, cancelToken) {
    return api.get(baseUri, {
      params: {
        query,
        limit,
      },
      cancelToken,
    });
  },

  show(id) {
    return api.get(`${baseUri}/${id}`);
  },

  dowload(id) {
    return api.get(`${baseUri}/${id}?format=pdf`);
  },

  store(data) {
    return api.post(`${baseUri}`, data);
  },
};



// WEBPACK FOOTER //
// ./src/js/api/order.js